import React from 'react';
import { useWorkHook } from '../../hooks';
import { Heading, WorkFilter, WorkFilterItem, WorkPortfolio } from '../../styles';
import { AppWrap, MotionWrap } from '../../wrapper';
import WorkCard from './WorkCard';

const Work = () => {
	const { programmingLanguageArray, handleWorkFilter, filterWork, activeFilter, animateCard } =
		useWorkHook();

	return (
		<>
			<Heading>
				My <span> Portfolio</span> Section
			</Heading>
			<WorkFilter>
				{programmingLanguageArray.map((item, index) => (
					<WorkFilterItem
						item={item}
						activeFilter={activeFilter}
						key={index}
						onClick={() => handleWorkFilter(item)}
					>
						{item}
					</WorkFilterItem>
				))}
			</WorkFilter>

			<WorkPortfolio animate={animateCard} transition={{ duration: 0.5, delayChildren: 0.5 }}>
				{filterWork.map((work, index) => (
					<WorkCard key={index} work={work} />
				))}
			</WorkPortfolio>
		</>
	);
};

export default AppWrap(MotionWrap(Work), 'Projects', 'app__whitebg');
